import React from 'react';
import { DevAppEnvironments } from '~/constants/app-environments';
import './EnvironmentWatermark.scss';

const EnvironmentWatermark: React.FC = () => {
  const appEnvironment = window.location.hostname.split('.')[0];
  
  // Only show watermark for development environments
  if (!DevAppEnvironments.includes(appEnvironment)) {
    return null;
  }

  return (
    <div className="environment-watermark">
      <div className="watermark-pattern">
        {Array.from({ length: 200 }, (_, index) => (
          <div key={index} className="watermark-text">
            {appEnvironment.toUpperCase()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EnvironmentWatermark;